import ActionTypes from './actionTypes';

/**
 * Get plastic types list
 * */
export function getPlasticTypesList(limit, offset, sortColumn, sortDirection, searchTerm) {
  return {
    type: ActionTypes.MAINTENANCE.PLASTIC_TYPES_LIST.REQUEST,
    payload: {
      limit,
      offset,
      sortColumn,
      sortDirection,
      searchTerm,
    },
  };
}

export function getPlasticTypesListSuccess(response) {
  return {
    type: ActionTypes.MAINTENANCE.PLASTIC_TYPES_LIST.SUCCESS,
    payload: {
      plasticTypesList: response.result,
      plasticTypesListResultSize: response.resultSize,
    },
  };
}

export function getPlasticTypesListFailure() {
  return {
    type: ActionTypes.MAINTENANCE.PLASTIC_TYPES_LIST.FAILURE,
  };
}

/**
 * Get plastic type
 * */
export function getPlasticType(id) {
  return {
    type: ActionTypes.MAINTENANCE.PLASTIC_TYPE.REQUEST,
    payload: {
      id,
    },
  };
}

export function getPlasticTypeSuccess(response) {
  return {
    type: ActionTypes.MAINTENANCE.PLASTIC_TYPE.SUCCESS,
    payload: {
      plasticType: response,
    },
  };
}

export function getPlasticTypeFailure() {
  return {
    type: ActionTypes.MAINTENANCE.PLASTIC_TYPE.FAILURE,
  };
}

/**
 * Reset plastic type
 * */
export function resetPlasticType() {
  return {
    type: ActionTypes.MAINTENANCE.PLASTIC_TYPE_RESET.REQUEST,
  };
}

/**
 * Create plastic type
 * */
export function createPlasticType(request) {
  return {
    type: ActionTypes.MAINTENANCE.CREATE_PLASTIC_TYPE.REQUEST,
    payload: {
      request,
    },
  };
}

export function createPlasticTypeSuccess() {
  return {
    type: ActionTypes.MAINTENANCE.CREATE_PLASTIC_TYPE.SUCCESS,
  };
}

export function createPlasticTypeFailure(exception) {
  return {
    type: ActionTypes.MAINTENANCE.CREATE_PLASTIC_TYPE.FAILURE,
    payload: {
      errorMessage: exception?.response?.data?.errorMessage,
    },
  };
}

export function resetCreatePlasticType() {
  return {
    type: ActionTypes.MAINTENANCE.CREATE_PLASTIC_TYPE.RESET,
  };
}

/**
 * Update plastic type
 * */
export function updatePlasticType(id, request) {
  return {
    type: ActionTypes.MAINTENANCE.UPDATE_PLASTIC_TYPE.REQUEST,
    payload: {
      id,
      request,
    },
  };
}

export function updatePlasticTypeSuccess() {
  return {
    type: ActionTypes.MAINTENANCE.UPDATE_PLASTIC_TYPE.SUCCESS,
  };
}

export function updatePlasticTypeFailure() {
  return {
    type: ActionTypes.MAINTENANCE.UPDATE_PLASTIC_TYPE.FAILURE,
  };
}

export function resetUpdatePlasticType() {
  return {
    type: ActionTypes.MAINTENANCE.UPDATE_PLASTIC_TYPE.RESET,
  };
}

/**
 * Get single scheduled maintenance
 * */
export function getScheduledMaintenance(id) {
  return {
    type: ActionTypes.MAINTENANCE.GET_SCHEDULE.REQUEST,
    payload: {
      id,
    },
  };
}

export function getScheduledMaintenanceSuccess(response) {
  return {
    type: ActionTypes.MAINTENANCE.GET_SCHEDULE.SUCCESS,
    payload: {
      scheduledMaintenance: response,
    },
  };
}

export function getScheduledMaintenanceFailure() {
  return {
    type: ActionTypes.MAINTENANCE.GET_SCHEDULE.FAILURE,
  };
}

/**
 * Get scheduled maintenance list
 * */
export function getScheduledMaintenanceList(
  startDate,
  endDate,
  pageNumber,
  pageSize,
  sortColumn,
  sortDirection,
  searchTerm
) {
  return {
    type: ActionTypes.MAINTENANCE.GET_SCHEDULES_LIST.REQUEST,
    payload: {
      startDate,
      endDate,
      pageNumber,
      pageSize,
      sortColumn,
      sortDirection,
      searchTerm,
    },
  };
}

export function getScheduledMaintenanceListSuccess(response) {
  return {
    type: ActionTypes.MAINTENANCE.GET_SCHEDULES_LIST.SUCCESS,
    payload: {
      scheduledMaintenanceList: response.result,
      scheduledMaintenanceListSize: response.resultSize,
    },
  };
}

export function getScheduledMaintenanceListFailure() {
  return {
    type: ActionTypes.MAINTENANCE.GET_SCHEDULES_LIST.FAILURE,
  };
}

/**
 * Create scheduled maintenance
 * */
export function createScheduledMaintenance(request) {
  return {
    type: ActionTypes.MAINTENANCE.CREATE_SCHEDULE.REQUEST,
    payload: {
      request,
    },
  };
}

export function createScheduledMaintenanceSuccess() {
  return {
    type: ActionTypes.MAINTENANCE.CREATE_SCHEDULE.SUCCESS,
  };
}

export function createScheduledMaintenanceFailure(exception) {
  return {
    type: ActionTypes.MAINTENANCE.CREATE_SCHEDULE.FAILURE,
    payload: {
      errorMessage: exception?.response?.data?.errorMessage,
    },
  };
}

export function resetCreateScheduledMaintenance() {
  return {
    type: ActionTypes.MAINTENANCE.CREATE_SCHEDULE.RESET,
  };
}

/**
 * Update scheduled maintenance
 * */
export function updateScheduledMaintenance(id, request) {
  return {
    type: ActionTypes.MAINTENANCE.UPDATE_SCHEDULE.REQUEST,
    payload: {
      id,
      request,
    },
  };
}

export function updateScheduledMaintenanceSuccess() {
  return {
    type: ActionTypes.MAINTENANCE.UPDATE_SCHEDULE.SUCCESS,
  };
}

export function updateScheduledMaintenanceFailure(error) {
  return {
    type: ActionTypes.MAINTENANCE.UPDATE_SCHEDULE.FAILURE,
    payload: {
      errorMessage: error?.response?.data?.errorMessage,
    },
  };
}

export function resetUpdateScheduledMaintenance() {
  return {
    type: ActionTypes.MAINTENANCE.UPDATE_SCHEDULE.RESET,
  };
}

/**
 * Delete scheduled maintenance
 * */
export function deleteScheduledMaintenance(id, request) {
  return {
    type: ActionTypes.MAINTENANCE.DELETE_SCHEDULE.REQUEST,
    payload: {
      id,
      request,
    },
  };
}

export function deleteScheduledMaintenanceSuccess() {
  return {
    type: ActionTypes.MAINTENANCE.DELETE_SCHEDULE.SUCCESS,
  };
}

export function deleteScheduledMaintenanceFailure() {
  return {
    type: ActionTypes.MAINTENANCE.DELETE_SCHEDULE.FAILURE,
  };
}

export function resetDeleteScheduledMaintenance() {
  return {
    type: ActionTypes.MAINTENANCE.DELETE_SCHEDULE.RESET,
  };
}
